import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import Cookies from "js-cookie";

// Initialize i18next and export the promise
const initPromise = i18n
  .use(HttpBackend) // Load translations from JSON files
  .use(initReactI18next) // Bind to React
  .init({
    // Read initial language from cookie (your existing system)
    lng: Cookies.get("language") || "fr",
    fallbackLng: ["fr", "eng"],

    // Support all your current language codes
    supportedLngs: ["eng", "fr", "es"],

    // Where to load translation files from
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    // Start with just 'translation' namespace
    ns: ["translation"],
    defaultNS: "translation",

    // Useful for debugging during migration
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    // React specific options
    react: {
      useSuspense: false, // Disable suspense to avoid loading issues during migration
    },
  });

export default i18n;
export { initPromise };
